// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import touch from "vue-directive-touch";
Vue.use(touch);
//md5加密
import md5 from "js-md5";
Vue.prototype.$md5 = md5;
import aes from "@/api/aes.js";
global.aes = aes;
//ElementUI
import ElementUI from "element-ui";
import "@/assets/element-ul/index.css";
Vue.use(ElementUI, {
    size: "small"
});
// 修改 el-dialog 默认点击遮照为不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;
//axios
import {
    server
} from "@/api/http-service";
Vue.prototype.$server = server;
import axios from "axios";
Vue.prototype.$axios = axios;

//兼容ie
import "babel-polyfill";
import promise from "es6-promise";
promise.polyfill();

//图标
import "@/assets/icon/iconfont.css";

//滚动分页
import infiniteScroll from "vue-infinite-scroll";
Vue.use(infiniteScroll);

//读取参数
import urlParam from "@/api/getUrlParam";
global.urlParam = urlParam;

//时间插件
import dateTime from "@/api/dateTime";
global.dateTime = dateTime;

// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole()
//赋值
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import visibility from 'vue-visibility-change';
Vue.use(visibility);

// import mui from './assets/js/mui.min.js'
// Vue.prototype.mui = mui;

import refreshTokenExpiration from "@/api/refreshTokenExpiration.js";
global.refreshTokenExpiration = refreshTokenExpiration;
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: "#app",
    router,
    components: {
        App
    },
    template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js